import utils from "@src/common/utils";
const tableOption = function (that) {
  return {
    view: "查看",
    page: true,
    selection: false,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    emptyText: "暂无数据",
    column: [
      {
        label: "状态",
        hide: true,
        prop: "taskStatus",
        // search: true,
        span: 12,
        align: "center",
        type: "select",
        dicData: [
          {
            label: "未开始",
            value: 0
          },
          {
            label: "执行中",
            value: 1
          },
          {
            label: "已完成",
            value: 2
          }
        ]
      },
      {
        label: "日期范围",
        hide: true,
        prop: "dateRange",
        type: "daterange",
        search: true,
        // searchslot: true,
        span: 12,
        align: "center"
      },
      {
        label: "任务名称",
        prop: "taskName",
        search: true,
        viewDisplay: true,
        span: 12,
        align: "center"
      },
      {
        label: "开始时间",
        prop: "startTime",
        // search: true,
        viewDisplay: true,
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return value != null && value != ""
            ? utils.getDateStr(value, "YYYY-MM-DD HH:mm:ss")
            : "";
        }
      },
      {
        label: "完成时间",
        prop: "endTime",
        // search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return value != null && value != ""
            ? utils.getDateStr(value, "YYYY-MM-DD HH:mm:ss")
            : "";
        }
      },
      {
        label: "责任人",
        prop: "processorName",
        // search: true,
        viewDisplay: true,
        span: 12,
        align: "center"
      },
      {
        label: "打卡进度",
        prop: "processorName",
        // search: true,
        viewDisplay: true,
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return row.realSignCount + "/" + row.signCount;
        }
      },
      {
        label: "是否打卡异常",
        prop: "cardStatus",
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return row.signCount == row.realSignCount ? "否" : "是";
        }
      },
      {
        label: "发现问题",
        prop: "isAlarm",
        // search: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return row.alarms.length > 0 ? "是" : "无";
        }
      }
    ]
  };
};
export default tableOption;
